/* eslint-disable no-useless-computed-key */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '915px',
    margin: '2% auto 0',
    padding: '0 10px 20px',
    '@media (max-width: 1024px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  imageContainer: {
    maxWidth: '380px',
    position: 'relative',
    zIndex: 0,
    flex: '1 auto',
    '@media (max-width: 1024px)': {
      marginBottom: '20px'
    }
  },
  imageContainerMask: {
    position: 'absolute',
    zIndex: -1,
    width: '100%',
    top: '27px',
    right: '10px',
    bottom: '-27px',
    borderWidth: '10px',
    borderStyle: 'solid',
    borderColor: 'rgba(202, 164, 137, 0.3)',
    boxSizing: 'border-box'
  },
  image: {
    margin: '0 0 0 17px',
    height: '100%',
    maxWidth: '100%',
    objectFit: 'cover'
  },
  descriptionContainer: {
    width: '100%',
    maxWidth: '417px',
    flex: '1 auto',
    '@media (max-width: 1024px)': {
      marginTop: '30px'
    }
  },
  descriptionMainHeading: {
    fontSize: '28px',
    color: '#000000',
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '1.2',
    marginBottom: '20px'
  },
  descriptionSecondaryHeading: {
    fontSize: '24px',
    color: '#000000',
    fontWeight: 400,
    textTransform: 'uppercase',
    lineHeight: '1.2',
    marginBottom: '10px'
  },
  descriptionContent: {
    fontSize: '14px',
    color: '#000000',
    fontWeight: 400,
    lineHeight: '1.5',
    paddingBottom: '35px'
  }
}));

const AboutUsProviderSectionPreview = ({
  providerImage,
  providerMainHeading,
  providerSecondaryHeading,
  providerContent
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.imageContainer}>
        <div className={classes.imageContainerMask} />
        <img
          className={classes.image}
          src={providerImage}
          alt="Provider Image"
        />
      </div>
      <div className={classes.descriptionContainer}>
        <div className={classes.descriptionMainHeading}>
          {providerMainHeading}
        </div>
        <div className={classes.descriptionSecondaryHeading}>
          {providerSecondaryHeading}
        </div>
        <div
          className={classes.descriptionContent}
          dangerouslySetInnerHTML={{__html: providerContent}}
        />
      </div>
    </div>
  );
};

export default AboutUsProviderSectionPreview;
